import { useGetConnectionQuery } from '@/api'
import { AvitoImportDialog } from '@/components/avito-import-dialog'

interface AddPropertyFromAvitoDialogProps {
	open:         boolean
	onOpenChange: (open: boolean) => void
}

export function AddPropertyFromAvitoDialog({ open, onOpenChange }: AddPropertyFromAvitoDialogProps) {
	const { data } = useGetConnectionQuery('AVITO', { skip: !open })

	return (
		<AvitoImportDialog
			connectionId={data?.connection?.isActive ? data.connection.id : undefined}
			open={open}
			onOpenChange={onOpenChange}
		/>
	)
}
